/*
    微信编译页面权限字典
*/
'use strict';
angular.module('wechatBtnServiceModule', ['weixinMassSendModule', 'weixinShowMassSendModule', 'wxPreviewModule', 'wxPreviewSuccessModule', 'weixinLayoutEditorModule', 'weixinAddCompModule', 'transmissionModule']).factory('wechatBtnService', ['$modal', '$q', 
    function($modal, $q) {
        return {
        // 微信待编平台权限
            initWechatCompBtn: function() {
                var btnRights = {
                    240: {
                        'OPERDESC': '新建',
                        'OPERNAME': 'wechat.daibian.xinjian',
                    },
                    241: {
                        'OPERDESC': '编辑',
                        'OPERNAME': 'wechat.daibian.bianji',
                    },
                    242: {
                        'OPERDESC': '送审',
                        'OPERNAME': 'wechat.daibian.songshen',
                    },
                    243: {
                        'OPERDESC': '送签',
                        'OPERFUN': 'wechat.daibian.qianfa',
                    },
                    244: {
                        'OPERDESC': '发稿单',
                        'OPERNAME': 'wechat.daibian.fagaodan',
                    },
                    251: {
                        'OPERDESC': '废稿',
                        'OPERFUN': 'wechat.daibian.feigao',
                    },
                    252: {
                        'OPERDESC': '外发',
                        'OPERNAME': 'wechat.daibian.waifa',
                    },
                    253: {
                        'OPERDESC': '收藏',
                        'OPERNAME': 'wechat.daibian.shoucang',
                    },
                };
                return btnRights;
            },
            // 微信待审平台权限
            initWechatPenBtn: function() {
                var btnRights = {
                    256: {
                        'OPERDESC': '编辑',
                        'OPERNAME': 'wechat.daishen.bianji',
                    },
                    257: {
                        'OPERDESC': '送签',
                        'OPERNAME': 'wechat.daishen.qianfa',
                    },
                    258: {
                        'OPERDESC': '撤稿',
                        'OPERNAME': 'wechat.daishen.tuigao',
                    },
                    259: {
                        'OPERDESC': '发稿单',
                        'OPERNAME': 'wechat.daishen.fagaodan',
                    },
                    260: {
                        'OPERDESC': '外发',
                        'OPERNAME': 'wechat.daishen.waifa',
                    },
                    261: {
                        'OPERDESC': '收藏',
                        'OPERNAME': 'wechat.daishen.shoucang',
                    },
                };
                return btnRights;
            },
            // 微信已送签平台权限
            initWechatSignBtn: function() {
                var btnRights = {
                    262: {
                        'OPERDESC': '编辑',
                        'OPERNAME': 'wechat.yiqianfa.bianji',
                    },
                    263: {
                        'OPERDESC': '取消送签',
                        'OPERNAME': 'wechat.yiqianfa.chegao',
                    },
                    264: {
                        'OPERDESC': '外发',
                        'OPERNAME': 'wechat.yiqianfa.waifa',
                    },
                    265: {
                        'OPERDESC': '收藏',
                        'OPERNAME': 'wechat.yiqianfa.shoucang',
                    },
                };
                return btnRights;
            },
            // 微信已送签平台群发功能
            massSend: function(items, type, success, picWordId) {
                var modalInstance = $modal.open({
                    templateUrl: './editingCenter/weixin/service/massSend/weixinMassSend_tpl.html',
                    windowClass: 'weixinMassSend',
                    backdrop: false,
                    controller: 'weixinMassSendController',
                    resolve: {
                        draftParams: function() {
                            return {
                                'items': items,
                                'type': type,
                                'picWordId': picWordId,
                            };
                        },
                    },
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            },
            showItems: function(items, success) {
                var modalInstance = $modal.open({
                    templateUrl: './editingCenter/weixin/service/showMassSend/showMassSend_tpl.html',
                    windowClass: 'weixinMassSend',
                    backdrop: false,
                    controller: 'weixinShowMassSendController',
                    resolve: {
                        draftParams: function() {
                            return {
                                'items': items,
                            };
                        },
                    },
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            },

            /**
             * [foregoingPreview description]
             * @param   {[type]}  items       [items description]
             * @param   {[type]}  methodname  [methodname description]
             * @param   {[type]}  type        [type description]
             * @param   {[type]}  picWordId   [picWordId description]
             * @return  {[type]}              [return description]
             */
            foregoingPreview: function(items, methodname, type, picWordId) {
                let defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: './editingCenter/weixin/service/foregoingPreview/preview_tpl.html',
                    windowClass: 'foregoingWxPreview',
                    backdrop: false,
                    controller: 'wxForegoingPreviewController',
                    resolve: {
                        draftParams: function() {
                            return {
                                'items': items,
                                'type': type,
                                'methodname': methodname,
                                'picWordId': picWordId
                            };
                        }
                    }
                });
                modalInstance.result.then((result) => {
                    defer.resolve(result);
                }, (error) => {
                    defer.reject(error);
                });
                return defer.promise;
            },

            /**
             * [wxPreview description] 微信预览
             * @param   {[type]}  items       [items description]
             * @param   {[type]}  methodname  [methodname description]
             * @param   {[type]}  type        [type description]
             * @param   {[type]}  success     [success description]
             * @param   {[type]}  picWordId   [picWordId description]
             * @return  {[type]}              [return description]
             */
            wxPreview: function(items, methodname, type, success, picWordId) {
                var modalInstance = $modal.open({
                    templateUrl: './editingCenter/weixin/service/wxPreview/wxPreview_tpl.html',
                    windowClass: 'wxPreview',
                    backdrop: false,
                    controller: 'wxPreviewController',
                    resolve: {
                        draftParams: function() {
                            return {
                                'items': items,
                                'type': type,
                                'methodname': methodname,
                                'picWordId': picWordId,
                            };
                        },
                    },
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            },
            wxPreviewSuccess: function(success, msg, bur, accounts) {
                var modalInstance = $modal.open({
                    templateUrl: './editingCenter/weixin/service/wxPreviewSuccess/wxPreviewSuccess_tpl.html',
                    windowClass: 'wxPreviewSuccess',
                    backdrop: false,
                    controller: 'wxPreviewSuccessController',
                    resolve: {
                        draftParams: function() {
                            return {
                                'type': bur,
                                'msg': msg,
                                'accounts': accounts,
                            };
                        },
                    },
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            },
            wxLayoutEditor: function(items, picwordid, success) {
                var modalInstance = $modal.open({
                    templateUrl: './editingCenter/weixin/service/layoutEditor/layoutEditor.html',
                    windowClass: 'wxLESuccess',
                    backdrop: false,
                    controller: 'weixinLayoutEditorController',
                    resolve: {
                        draftParams: function() {
                            return {
                                'items': items,
                                'picwordid': picwordid,
                            };
                        },
                    },
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            },
            weixinAddComp: function(array, success) {
                var modalInstance = $modal.open({
                    templateUrl: './editingCenter/weixin/service/addComp/addComp.html',
                    windowClass: 'wxaddComp',
                    backdrop: false,
                    controller: 'weixinAddCompController',
                    resolve: {
                        draftParams: function() {
                            return {
                                'array': array,
                            };
                        },
                    },
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            },
            wxTransmission: function(success) {
                var modalInstance = $modal.open({
                    templateUrl: './editingCenter/weixin/service/transmission/transmission.html',
                    windowClass: 'transmission',
                    backdrop: false,
                    controller: 'transmissionController',
                    resolve: {
                        draftParams: function() {
                            return {};
                        },
                    },
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            },
        };
    }]);
